export default __webpack_public_path__ + "static/media/course8.5b600705.webp";